import FileRowContainerProps from './FileRowContainer.types';

export const FileRowContainer = ({
  fileName,
  onMouseEnter,
  onMouseLeave,
  setRefElement,
  children,
}: FileRowContainerProps): React.ReactElement => (
  <span
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    ref={setRefElement ? (element) => setRefElement(fileName, element as HTMLDivElement) : undefined}
  >
    {children}
  </span>
);
